import {getSourcesData} from '../helpers/sources';
import {request} from '../helpers/request';
import {t} from '../helpers/translate.js';

let config = require('config');

function updateRequestStatus (){
  this.setState({requestStatus: false})
}

export function getSourceNameAndCc(sourceName, context) {
  request(`${config.default.api}/sources/`, 'GET', null, (responseData, statusCode) => {
    if (statusCode == 200) {
      const source = responseData.sources.find(
        (source) => {return source.name === sourceName}
      );

      context.setState({
        sourceFullName: (sourceName == 'universal') ? t('Search Policies') : `${t(source.full_name)} ${t(source.category)}`,
        sourceCC: source.cc
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/helpers/getSourceData.js